import AppShell from "@/components/AppShell";
import { Mail, Phone, MapPin, Globe, ShieldCheck } from "lucide-react";

export default function Contact() {
  return (
    <AppShell>
      <section className="max-w-[860px] mx-auto px-5 sm:px-8 py-14 sm:py-20" data-testid="contact-page">
        <div className="pnc-eyebrow mb-4">Get in touch</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#F5F5F5] tracking-tight leading-[1.05] mb-4">
          Contact HR
        </h1>
        <p className="text-[#A8A8A8] text-base sm:text-lg max-w-xl leading-relaxed mb-12">
          For questions about your absence, a rejected notification, or your data — reach the PNC HR team using
          any of the channels below.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <ContactCard
            icon={<Mail className="w-5 h-5" strokeWidth={2}/>}
            eyebrow="Email"
            title="admin@pncunique.com"
            href="mailto:admin@pncunique.com"
            hint="We reply within one working day."
            testid="contact-email"
          />
          <ContactCard
            icon={<Phone className="w-5 h-5" strokeWidth={2}/>}
            eyebrow="Phone"
            title="0333 090 5024"
            href="tel:03330905024"
            hint="Mon–Fri, 08:00–17:00 UK time."
            testid="contact-phone"
          />
          <ContactCard
            icon={<Globe className="w-5 h-5" strokeWidth={2}/>}
            eyebrow="Website"
            title="www.pncunique.com"
            href="https://www.pncunique.com"
            hint="Main company website."
            external
            testid="contact-website"
          />
          <ContactCard
            icon={<ShieldCheck className="w-5 h-5" strokeWidth={2}/>}
            eyebrow="Data requests"
            title="Data rights & GDPR"
            href="mailto:admin@pncunique.com?subject=UK%20GDPR%20request"
            hint="Access, correction, deletion — 1-month response."
            testid="contact-gdpr"
          />
        </div>

        <div className="mt-10 pnc-card p-6 sm:p-8">
          <div className="pnc-eyebrow mb-3 flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" strokeWidth={2}/> Registered address
          </div>
          <div className="text-[#F5F5F5] text-base leading-relaxed">
            PNC UNIQUE LTD<br/>
            Headlands House<br/>
            1 Kings Court<br/>
            Kettering Parkway<br/>
            Kettering, Northamptonshire<br/>
            NN15 6WJ<br/>
            United Kingdom
          </div>
          <div className="mt-4 text-[13px] text-[#6B6B6B]">
            Registered in England and Wales · ICO Registration <span className="text-[#A8A8A8]">ZB865873</span>
          </div>
        </div>
      </section>
    </AppShell>
  );
}

function ContactCard({ icon, eyebrow, title, hint, href, external, testid }) {
  const Comp = href ? "a" : "div";
  const extra = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Comp
      href={href}
      {...extra}
      data-testid={testid}
      className="pnc-card p-5 sm:p-6 block transition-colors hover:border-[#C0C0C0]/60"
    >
      <div className="flex items-center gap-2 text-[#C0C0C0] mb-3">
        {icon}
        <span className="pnc-eyebrow">{eyebrow}</span>
      </div>
      <div className="text-[#F5F5F5] text-lg font-semibold tracking-tight mb-1 break-words">{title}</div>
      <div className="text-[13px] text-[#A8A8A8]">{hint}</div>
    </Comp>
  );
}
